const factboxes = document.querySelectorAll('.fact-box-read-more');

factboxes.forEach(factbox => {
    const btn = factbox.querySelector('.fact-box-toggle');
    const btnText = btn?.querySelector('.btn-text');

    if (!btn || !btnText) return;

    btn.addEventListener('click', () => {
        const isExpanded = factbox.getAttribute('data-expanded') === 'true';
        factbox.setAttribute('data-expanded', String(!isExpanded));
        btn.setAttribute('aria-expanded', String(!isExpanded));

        btnText.textContent = !isExpanded ? 'Vis mindre' : 'Vis mere';
        btn.classList.toggle('expanded', !isExpanded);
    });
});